import Modal from 'react-bootstrap/Modal';
import { useLocationChange, useSocialShareLinks } from '@hooks';
import { useShareDialog } from '@providers';
import { IconButton } from '../../../components';
import { useTranslation } from 'react-i18next';

export const ShareDialog = () => {
  const { t } = useTranslation();

  const { shareDialogProperty: property, hideShareDialog } = useShareDialog();
  const socialShareLinks = useSocialShareLinks(property);

  const title = property ? `${property.subCategory}, ${property.area}` : '';
  const mainThumb =
    property?.mainImages?.[0]?.thumbUrl || property?.mainImages?.[0]?.url || '';

  useLocationChange(hideShareDialog);

  return (
    <Modal show={!!property} onHide={hideShareDialog}>
      <Modal.Header>
        <button
          type='button'
          className='close'
          aria-label='Close'
          onClick={hideShareDialog}
        >
          <span aria-hidden='true'>&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {property && (
          <>
            <div className='d-flex gap-3 align-items-center'>
              <img
                src={mainThumb}
                alt={`Photo of ${property.category} property, ${property.area}`}
                height='60'
              />
              <span>
                {t('socialShareWidget.share')}
                <h4>{title}</h4>
              </span>
            </div>
            <hr />
            <div className='d-flex justify-content-center'>
              {socialShareLinks.map((link) => (
                <IconButton
                  key={link.title}
                  variant='outline-primary'
                  href={link.href}
                  title={link.title}
                  target='_blank'
                  rel='noopener noreferrer'
                  onClick={link.onClick}
                >
                  {link.icon}
                </IconButton>
              ))}
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};
